const data = (collection, keyword) => (
  collection
    && Object.values(collection).filter((item) => {
      let available = false;
      if (
        item.attributes.first_name
          .toLowerCase()
          .includes(keyword.toLowerCase())
        || item.attributes.last_name
          .toLowerCase()
          .includes(keyword.toLowerCase())
        || item.attributes.email.toLowerCase().includes(keyword.toLowerCase())
      ) available = true;

      return available;
    })
);

export default data;
